// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_spiral_vase_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_spiral_vase_shade: ModuleSchema = {
  "id": "core_spiral_vase_shade",
  "uniqueId": "B3D_9X08H",
  "createdAt": "2026-10-02T17:42:52.277Z",
  "updatedAt": "2026-10-30T10:31:13.344Z",
  "label": "Spiral Shade",
  "description": "core_spiral_vase_shade parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SPIR1",
    "lampshade",
    "spiral-ribs"
  ],
  "sliders": [
    {
      "key": "shadeBellyDia",
      "label": "Belly Diameter (Ø)",
      "min": 60,
      "max": 300,
      "step": 1,
      "default": 150,
      "unit": "mm"
    },
    {
      "key": "shadeBotDia",
      "label": "Bottom Diameter (Ø)",
      "min": 40,
      "max": 280,
      "step": 1,
      "default": 78,
      "unit": "mm"
    },
    {
      "key": "shadeTopDia",
      "label": "Top Diameter (Ø)",
      "min": 40,
      "max": 280,
      "step": 1,
      "default": 92,
      "unit": "mm"
    },
    {
      "key": "wallThickness",
      "label": "Wall Thickness",
      "min": 0.8,
      "max": 8,
      "step": 0.1,
      "default": 2.4,
      "unit": "mm"
    },
    {
      "key": "bottomThick",
      "label": "Bottom Disc Thickness",
      "min": 1,
      "max": 12,
      "step": 0.2,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "holeDia",
      "label": "E27 Socket Bore (Ø)",
      "min": 10,
      "max": 60,
      "step": 0.5,
      "default": 41.5,
      "unit": "mm"
    },
    {
      "key": "topOpeningDia",
      "label": "Top Opening (Ø, 0 = closed)",
      "min": 0,
      "max": 200,
      "step": 1,
      "default": 0,
      "unit": "mm"
    },
    {
      "key": "ribCount",
      "label": "Rib / Flute Count",
      "min": 6,
      "max": 160,
      "step": 1,
      "default": 48
    },
    {
      "key": "ribDepth",
      "label": "Rib Groove Depth",
      "min": 0,
      "max": 12,
      "step": 0.25,
      "default": 2.5,
      "unit": "mm"
    },
    {
      "key": "twistTurns",
      "label": "Rib Twist (turns over height)",
      "min": -4,
      "max": 4,
      "step": 0.05,
      "default": 0
    },
    {
      "key": "segments",
      "label": "Angular Resolution",
      "min": 48,
      "max": 512,
      "step": 8,
      "default": 192
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [],
  "objects": [],
  "exportGroups": []
};
